module.exports = "<md-toast\n  ng-class=\"\n  {\n    'notification-toast-haserror': $ctrl.options.type === 'error',\n    'notification-toast-success': $ctrl.options.type === 'success'\n  }\"\n>\n  <span class=\"md-toast-text\" flex>{{ ::$ctrl.toastMessage }}</span>\n  <md-button class=\"md-icon-button\" ng-click=\"$ctrl.close()\">\n    <md-icon>close</md-icon>\n  </md-button>\n</md-toast>\n";


//////////////////
// WEBPACK FOOTER
// ./src/components/notification/toast/toast.html
// module id = 781
// module chunks = 0